import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, Phone } from "lucide-react";
import { cn } from "@/lib/utils";
import { DEALER } from "@/data/dealer";
import { Logo } from "@/components/layout/Logo";
import { MobileMenu } from "@/components/layout/MobileMenu";
import { NAV } from "@/components/layout/nav";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [pathname]);

  return (
    <header
      className={cn(
        "sticky top-0 z-40 border-b border-line bg-white transition-shadow duration-300",
        scrolled && "shadow-[0_10px_30px_-22px_rgba(11,13,18,0.45)]",
      )}
      data-testid="site-header"
    >
      <div className="container-x flex h-16 items-center gap-4 lg:h-20">
        <Logo className="h-6 sm:h-8 lg:h-9" />
        <nav aria-label="Main" className="ml-auto hidden items-center lg:flex">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} className="nav-link" data-testid={`nav-${n.id}-link`}>
              {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="ml-auto flex items-center gap-2 lg:ml-3">
          <a
            href={DEALER.phone.href}
            className="hidden items-center gap-2 px-3 text-sm font-semibold text-ink transition-colors hover:text-brand xl:inline-flex"
            data-testid="header-call-link"
          >
            <Phone className="h-4 w-4" aria-hidden="true" />
            {DEALER.phone.display}
          </a>
          <Link to="/used-cars" className="btn btn-primary btn-sm px-3.5 sm:px-4" data-testid="header-view-stock-button">
            View Stock
          </Link>
          <button
            type="button"
            onClick={() => setMenuOpen(true)}
            className="inline-flex h-11 w-11 items-center justify-center rounded-md border border-line text-ink transition-colors hover:border-ink lg:hidden"
            aria-label="Open menu"
            aria-expanded={menuOpen}
            data-testid="mobile-menu-button"
          >
            <Menu className="h-5 w-5" />
          </button>
        </div>
      </div>
      <MobileMenu open={menuOpen} onOpenChange={setMenuOpen} />
    </header>
  );
};
